import {create} from 'apisauce';

export const http = create({
  // eslint-disable-next-line no-undef
  baseURL: (apiUrl),
  headers: {Accept: 'application/json'},
});
